import api from '../services/api';
import { createBaseModule } from './base';

export default createBaseModule( {
  state: {
    products: {},
    section_id: false,
    section: {},
    product_total: 0,
    noMoreProducts: false
  },
  mutations: {
    SET_DATA(state, {products, page, id}) {

      if (page > 1) {
        state.products[id] = state.products[id].concat(products.data.items)
      }
      else
        state.products[id] = products.data.items;
      if (state.products[id].length >= products.data.total)
        state.noMoreProducts = true;
      state.loaded = true; // Устанавливаем флаг, что данные загружены
      state.section = products.data.section;
      state.product_total = products.data.total;
    },
  },
  actions: {
    async fetchProducts({ commit, state }, {id, page, sort, filter={}, search='', first=false, page_size=false, withoutpage= false}) {
      if (id == undefined)
        return;

      if (state.products && state.products[id] && state.products[id].length > 0) {
        return;
      }

      state.section_id = id;

      if (page == 1) {
        commit('RESET_STATE');
        state.noMoreProducts = false;
      }

      let params = {
        page: page
      };
      if (filter)
        params.filter = filter;
      if (page_size)
        params.page_size = page_size;
      if (sort)
        params.sort = sort;
      if (search)
        params.q = search;
      if (filter) {
        params.filter = filter;
        params.set_filter = 'Y';
      }
      if (withoutpage)
        params.withoutpage = withoutpage;
      /*{
        page: page,
            filter: filter,
          sort: sort,
          q: search
      }*/

      try {
        commit('SET_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await api.get('api/catalog/elements/'+id+'/', {
          params: params
        });
        if (response?.data?.data?.items) {
          commit('SET_DATA', {products: response.data, page: page, id: id});
          commit('SET_ERROR', null);
        }
        else {
          if (response?.data?.errors && Array.isArray(response.data.errors)) {
            // Проверяем есть ли в массиве ошибки с числовым кодом или code_error
            const hasTechnicalError = response.data.errors.some(
                error => typeof error.code === 'number' || error.code === 'code_error'
            );

            if (hasTechnicalError) {
              commit('SET_ERROR', 'Техническая ошибка');
            } else {
              const errorMessages = response.data.errors
                  .map(error => error.message)
                  .join('. ');

              commit('SET_ERROR', errorMessages);
            }
          } else {
            commit('SET_ERROR', 'Произошла ошибка при выполнении операции');
          }


        }

      } catch (error) {
        commit('SET_ERROR', error.message?error.message:'Ошибка при загрузке');
      } finally {
        commit('SET_LOADING', false);
      }
    }
  },
  getters: {
    products: state => id => state.products[id],
    productsLoading: state => state.loading,
    productsError: state => state.error,
    productsLoaded: state => state.loaded,
    product_total: state => state.product_total,
    section: state => state.section,
    section_id: state => state.section_id,
    noMoreProducts: state => state.noMoreProducts
  }
})